// Fianly action, link and selection colors, shared by dashboard and access views.
// Status palettes remain independent. Upstream components use the blue token channel.
const FIANLY_THEME_CLASSES = [
  '![--blue-1:255_252_250]',
  '![--blue-2:255_247_242]',
  '![--blue-3:255_239_229]',
  '![--blue-4:255_226_208]',
  '![--blue-5:255_211_184]',
  '![--blue-6:249_187_148]',
  '![--blue-7:236_156_109]',
  '![--blue-8:222_121_65]',
  '![--blue-9:201_75_18]',
  '![--blue-10:174_61_12]',
  '![--blue-11:174_61_12]',
  '![--blue-12:87_38_18]',
  'dark:![--blue-1:28_23_20]',
  'dark:![--blue-2:36_27_22]',
  'dark:![--blue-3:52_32_22]',
  'dark:![--blue-4:67_38_23]',
  'dark:![--blue-5:82_46_27]',
  'dark:![--blue-6:102_56_31]',
  'dark:![--blue-7:133_70_35]',
  'dark:![--blue-8:172_86_38]',
  'dark:![--blue-9:201_75_18]',
  'dark:![--blue-10:174_61_12]',
  'dark:![--blue-11:255_174_130]',
  'dark:![--blue-12:255_226_208]',
  '![--solid-blue:255_239_229]',
  '![--solid-blue-2:255_247_242]',
  '![--text-blue:174_61_12]',
  'dark:![--solid-blue:67_38_23]',
  'dark:![--solid-blue-2:36_27_22]',
  'dark:![--text-blue:255_174_130]',
];

document.documentElement.classList.add(...FIANLY_THEME_CLASSES);
